//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { Enums } from "../../models/common"

//#region Module Imports

import { AlarmContextMenuService, ALARM_CONTEXT_MENU_SERVICE_NAME, IdAlarmEventGridContextMenuOptions } from '../alarm'
import { ConsumerContextMenuService, CONSUMER_CONTEXT_MENU_SERVICE_NAME, IdConsumerGridContextMenuOptions } from '../consumer'
import { DepositoryContextMenuService, DEPOSITORY_CONTEXT_MENU_SERVICE_NAME, DepositoryGridContextMenuOptions } from '../depository'
import { DeviceConnectionContextMenuService, DEVICE_CONNECTION_CONTEXT_MENU_SERVICE_NAME, IdDeviceConnectionGridContextMenuOptions } from '../device-connection'
import { DeviceContextMenuService, DEVICE_CONTEXT_MENU_SERVICE_NAME, SerialNbrGridContextMenuOptions } from '../device'
import { GroupingLocationContextMenuService, GroupingLocationGridContextMenuOptions, GROUPING_LOCATION_CONTEXT_MENU_SERVICE_NAME } from '../grouping-locations'
import { IssueContextMenuService, IdIssueGridContextMenuOptions, ISSUE_CONTEXT_MENU_SERVICE_NAME } from '../issue'
import { LocationContextMenuService, LOCATION_CONTEXT_MENU_SERVICE_NAME, IdLocationGridContextMenuOptions } from '../location'
import { MeterContextMenuService, METER_CONTEXT_MENU_SERVICE_NAME, IdMeterGridContextMenuOptions } from '../meter'
import { OperatorContextMenuService, OPERATOR_CONTEXT_MENU_SERVICE_NAME, IdOperatorGridContextMenuOptions } from '../operator'
import { ReportContextMenuService, REPORT_CONTEXT_MENU_SERVICE_NAME, IdReportGridContextMenuOptions } from '../report'
import { TariffContextMenuService, TariffGridContextMenuOptions, TARIFF_CONTEXT_MENU_SERVICE_NAME } from '../tariff'
import { TaskContextMenuService, TASK_CONTEXT_MENU_SERVICE_NAME, IdTaskGridContextMenuOptions } from '../task'

//#endregion


// #region Consts

export const GRID_CONTEXT_MENU_SERVICE_NAME = 'GridContextMenuService'
export const GRID_CONTEXT_MENU_SERVICE_PROVIDER_NAME = 'GridContextMenuServiceProvider'

// #endregion

export class GridContextMenuService {
    // #region Consts

    private static get LOG_PREFIX(): string { return '[SIMAX.Services.GridContextMenu]' }

    // #endregion

    // #region Ctor

    public constructor(
        private readonly alarmContextMenuService: AlarmContextMenuService,
        private readonly consumerContextMenuService: ConsumerContextMenuService,
        private readonly depositoryContextMenuService: DepositoryContextMenuService,
        private readonly deviceContextMenuService: DeviceContextMenuService,
        private readonly deviceConnectionContextMenuService: DeviceConnectionContextMenuService,
        private readonly groupingLocationContextMenuService: GroupingLocationContextMenuService,
        private readonly issueContextMenuService: IssueContextMenuService,
        private readonly locationContextMenuService: LocationContextMenuService,
        private readonly meterContextMenuService: MeterContextMenuService,
        private readonly operatorContextMenuService: OperatorContextMenuService,
        private readonly reportContextMenuService: ReportContextMenuService,
        private readonly tariffContextMenuService: TariffContextMenuService,
        private readonly taskContextMenuService: TaskContextMenuService
    ) { }

    // #endregion


    //#region Members

    public getContextMenuItems(moduleName: Enums.SimaxModuleName.Depository, options: DepositoryGridContextMenuOptions): any[]
    public getContextMenuItems(moduleName: Enums.SimaxModuleName.Grouping_Location, options: GroupingLocationGridContextMenuOptions): any[]
    public getContextMenuItems(moduleName: Enums.SimaxModuleName.Tariff, options: TariffGridContextMenuOptions): any[]
    public getContextMenuItems(moduleName: Enums.SimaxModuleName, options: any) {
        switch (moduleName) {
            case Enums.SimaxModuleName.Depository:
                return this.depositoryContextMenuService.getContextMenuItems(options as DepositoryGridContextMenuOptions)

            case Enums.SimaxModuleName.Grouping_Location:
                return this.groupingLocationContextMenuService.getContextMenuItems(options as GroupingLocationGridContextMenuOptions)

            case Enums.SimaxModuleName.Tariff:
                return this.tariffContextMenuService.getContextMenuItems(options as TariffGridContextMenuOptions)
        }
    }

    public getContextMenuItemsByReferenceType(referenceType: Enums.ReferenceType.IdAlarmEvent, options: IdAlarmEventGridContextMenuOptions): any[]
    public getContextMenuItemsByReferenceType(referenceType: Enums.ReferenceType.IdDeviceConnection, options: IdDeviceConnectionGridContextMenuOptions): any[]
    public getContextMenuItemsByReferenceType(referenceType: Enums.ReferenceType.IdConsumer, options: IdConsumerGridContextMenuOptions): any[]
    public getContextMenuItemsByReferenceType(referenceType: Enums.ReferenceType.IdIssue, options: IdIssueGridContextMenuOptions): any[]
    public getContextMenuItemsByReferenceType(referenceType: Enums.ReferenceType.IdLocation, options: IdLocationGridContextMenuOptions): any[]
    public getContextMenuItemsByReferenceType(referenceType: Enums.ReferenceType.IdMeter, options: IdMeterGridContextMenuOptions): any[]
    public getContextMenuItemsByReferenceType(referenceType: Enums.ReferenceType.IdOperator, options: IdOperatorGridContextMenuOptions): any[]
    public getContextMenuItemsByReferenceType(referenceType: Enums.ReferenceType.IdReport, options: IdReportGridContextMenuOptions): any[]
    public getContextMenuItemsByReferenceType(referenceType: Enums.ReferenceType.IdTask, options: IdTaskGridContextMenuOptions): any[]
    public getContextMenuItemsByReferenceType(referenceType: Enums.ReferenceType.SerialNbr, options: SerialNbrGridContextMenuOptions): any[]
    public getContextMenuItemsByReferenceType(referenceType: Enums.ReferenceType, options: any): any[] {
        if (options != null) {
            switch (referenceType) {
                case Enums.ReferenceType.IdAlarmEvent:
                    return this.alarmContextMenuService.getContextMenuItems(options as IdAlarmEventGridContextMenuOptions)

                case Enums.ReferenceType.IdConsumer:
                    return this.consumerContextMenuService.getContextMenuItems(options as IdConsumerGridContextMenuOptions)

                case Enums.ReferenceType.IdDeviceConnection:
                    return this.deviceConnectionContextMenuService.getContextMenuItems(options as IdDeviceConnectionGridContextMenuOptions)

                case Enums.ReferenceType.IdIssue:
                    return this.issueContextMenuService.getContextMenuItems(options as IdIssueGridContextMenuOptions)

                case Enums.ReferenceType.IdLocation:
                    return this.locationContextMenuService.getContextMenuItems(options as IdLocationGridContextMenuOptions)

                case Enums.ReferenceType.IdMeter:
                    return this.meterContextMenuService.getContextMenuItems(options as IdMeterGridContextMenuOptions)

                case Enums.ReferenceType.IdOperator:
                    return this.operatorContextMenuService.getContextMenuItems(options as IdOperatorGridContextMenuOptions)

                case Enums.ReferenceType.IdReport:
                    return this.reportContextMenuService.getContextMenuItems(options as IdReportGridContextMenuOptions)

                case Enums.ReferenceType.IdTask:
                    return this.taskContextMenuService.getContextMenuItems(options as IdTaskGridContextMenuOptions)

                case Enums.ReferenceType.SerialNbr:
                    return this.deviceContextMenuService.getContextMenuItems(options as SerialNbrGridContextMenuOptions)
            }
        }

        return []
    }

    //#endregion

}

export class GridContextMenuServiceProvider implements ng.IServiceProvider {

    // #region IServiceProvider Implementation 

    public $get = [
        ALARM_CONTEXT_MENU_SERVICE_NAME,
        CONSUMER_CONTEXT_MENU_SERVICE_NAME,
        DEPOSITORY_CONTEXT_MENU_SERVICE_NAME,
        DEVICE_CONTEXT_MENU_SERVICE_NAME,
        DEVICE_CONNECTION_CONTEXT_MENU_SERVICE_NAME,
        GROUPING_LOCATION_CONTEXT_MENU_SERVICE_NAME,
        ISSUE_CONTEXT_MENU_SERVICE_NAME,
        LOCATION_CONTEXT_MENU_SERVICE_NAME,
        METER_CONTEXT_MENU_SERVICE_NAME,
        OPERATOR_CONTEXT_MENU_SERVICE_NAME,
        REPORT_CONTEXT_MENU_SERVICE_NAME,
        TARIFF_CONTEXT_MENU_SERVICE_NAME,
        TASK_CONTEXT_MENU_SERVICE_NAME,
        function (
            alarmContextMenuService: AlarmContextMenuService,
            consumerContextMenuService: ConsumerContextMenuService,
            depositoryContextMenuService: DepositoryContextMenuService,
            deviceContextMenuService: DeviceContextMenuService,
            deviceConnectionContextMenuService: DeviceConnectionContextMenuService,
            groupingLocationContextMenuService: GroupingLocationContextMenuService,
            issueContextMenuService: IssueContextMenuService,
            locationContextMenuService: LocationContextMenuService,
            meterContextMenuService: MeterContextMenuService,
            operatorContextMenuService: OperatorContextMenuService,
            reportContextMenuService: ReportContextMenuService,
            tariffContextMenuService: TariffContextMenuService,
            taskContextMenuService: TaskContextMenuService
        ) {
            return new GridContextMenuService(
                alarmContextMenuService,
                consumerContextMenuService,
                depositoryContextMenuService,
                deviceContextMenuService,
                deviceConnectionContextMenuService,
                groupingLocationContextMenuService,
                issueContextMenuService,
                locationContextMenuService,
                meterContextMenuService,
                operatorContextMenuService,
                reportContextMenuService,
                tariffContextMenuService,
                taskContextMenuService
            )
        }]

    // #endregion
} 